import { useActiveAccount } from './useActiveAccount'

export const ROLE_ADMIN = 'AppCatalog.Admin'
export const ROLE_VIEWER = 'AppCatalog.Viewer'

export interface UserRoles {
  roles: string[]
  isAdmin: boolean
  isViewer: boolean
  hasAnyRole: boolean
}

export function useRoles(): UserRoles {
  const account = useActiveAccount()
  const claims = account?.idTokenClaims as { roles?: string[] } | undefined
  const roles = claims?.roles ?? []

  const isAdmin = roles.includes(ROLE_ADMIN)
  // Admins implicitly have viewer permissions (mirrors the API's require_role check).
  const isViewer = isAdmin || roles.includes(ROLE_VIEWER)

  return {
    roles,
    isAdmin,
    isViewer,
    hasAnyRole: isAdmin || isViewer,
  }
}
